const config = {
  // 环境标识
  ENV: process.env.REACT_APP_ENV || 'development',
  
  // API配置
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.aicaster.com.cn',
  
  // 应用基础URL
  APP_BASE_URL: process.env.REACT_APP_BASE_URL || window.location.origin,
  
  // 调试模式
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  
  // 获取当前环境信息
  getEnvironmentInfo() {
    return {
      env: this.ENV,
      apiUrl: this.API_BASE_URL,
      appUrl: this.APP_BASE_URL,
      debug: this.DEBUG
    };
  },
  
  // 检查是否为开发环境
  isDevelopment() {
    return this.ENV === 'development';
  },
  
  // 检查是否为生产环境
  isProduction() {
    return this.ENV.startsWith('production');
  },
  
  // 检查是否为测试环境
  isStaging() {
    return this.ENV === 'staging';
  }
};

// 在开发环境下输出配置信息
if (config.DEBUG) {
  console.log('🔧 应用配置信息:', config.getEnvironmentInfo());
}

export default config; 